import { generateBreadcrumbs } from './breadcrumbs';
import { generateFAQ } from './FAQ';

/* eslint-disable import/prefer-default-export */
export const genarateSchema = ({ faqs, scholarshipURL }) => {
  const graph = [generateBreadcrumbs({ scholarshipURL })];

  const faqSchemaEntry = generateFAQ(faqs);
  if (faqSchemaEntry) graph.push(faqSchemaEntry);

  const schema = {
    '@context': 'https://schema.org/',
    '@graph': graph
  };

  return schema;
};
